import React from "react"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import TextReveal from "@yumgmbh/gatsby-theme-yum-components/src/components/reveals/TextReveal"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import ButtonGroup from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/ButtonGroup"

const IntroTextBlock = ({ block }) => {
  return (
    <BlockWrapper
      block={block}
      blockWidth="container"
      showHeadline="true"
      blockDirection="vertical"
      className=""
    >
      <div className="mt-4 -mx-grid">
        <TextReveal className="lg:w-1/2 px-grid">
          <Richtext
            flow={block.flow}
            text={block.text}
            className="prose-lg text-ro-gray-500"
          />
          <ButtonGroup className="mt-8" buttons={block.buttons} />
        </TextReveal>
      </div>
    </BlockWrapper>
  )
}

export default IntroTextBlock
